import { useSelector } from 'react-redux';
import { Moment } from 'moment';

import { getBasketMode } from '@front/common/src/ducks/customer/basket';
import { formatDate, FORMATS } from '@front/common/src/utils/date';
import { getModifiedBooking } from '@front/common/src/ducks/customer/basket-selectors';
import { getCreatedAt } from '@front/common/src/utils/booking';

const formatDateForAPI = (date: Moment) => formatDate(date, FORMATS.DATETIME.TIMESTAMPS);

export const useVersionedAt = () => {
  const mode = useSelector(getBasketMode);
  const modificationBooking = useSelector(getModifiedBooking);

  return mode === 'modification' && !!modificationBooking
    ? formatDateForAPI(getCreatedAt(modificationBooking))
    : undefined;
};
